import { takeLatest } from 'redux-saga/effects';
import { ACTIONS } from '../actions/actionTypes';

export function * DISPATCH_MISSION () {
    yield takeLatest(ACTIONS.DISPATCH_MISSION, function * (action) {
        console.log(action.payload);
        window.alert(action.payload.mission.title);
    });
}



// WEBPACK FOOTER //
// ./src/sagas/missionSaga.js